// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 389 ? "1dd05252" : chunkId) + "." + {"389":"3b3fe3045bbd4917","654":"b27fe2671e8e0ee7"}[chunkId] + ".js";
};